import { render, staticRenderFns } from "./select-user-by-role.vue?vue&type=template&id=24f6694d&scoped=true"
import script from "./select-user-by-role.vue?vue&type=script&lang=js"
export * from "./select-user-by-role.vue?vue&type=script&lang=js"
import style0 from "./select-user-by-role.vue?vue&type=style&index=0&id=24f6694d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6694d",
  null
  
)

export default component.exports